// removed by extract-text-webpack-plugin
module.exports = {"variables":"\"../../../assets/stylesheets/variables.css\"","paddedForNavbar":"_15-uIrn7gODHiOpUuDWjwC","genericContainer":"_2ELtkcMpIJZ1yyH_kfj3I7","title":"_1xVEZf230X-cZ3JkoU-KHT _2IbHD4FVxtBnbNHEUw2mS3","subheader":"_3tfkBLzh4oNF67_ojQV2Pn","container":"tSMMu2RIv0X1_jRhcoIHJ _15-uIrn7gODHiOpUuDWjwC","mainContent":"_39eZUI12GZeuGBZB11yR94 _2ELtkcMpIJZ1yyH_kfj3I7","titleContainer":"_1rZDsZT8n5DCmz8sZO0pve","subtitle":"DDpcuH8LV8RoGr-XRGeRg _3tfkBLzh4oNF67_ojQV2Pn"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/my-account/my-account-menu-mobile/MyAccountMenuMobile.css
// module id = 863
// module chunks = 0